import React from 'react';
import { i18n } from 'core/i18n'

import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';

// Utulities
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper'

import './cryptoAssetsBanner.scss';

const { FormattedText, getLanguage } = i18n;


export const CryptoAssetsBalance = ({ balance, isFetchError }) => {
    const plainAmountObject = getPlainAmountObject({
        amount: balance,
        currency: "EUR"
    });

    return (
        <div className="crypto-assets crypto-assets--flat">
            <div className='crypto-assets__content'>
                <div className='crypto-assets__icon'>
                    <i className="icons icons--icon-crypto"></i>
                </div>
                <div className='crypto-assets__text'>
                    <FormattedText value="gp_crypto_asset-gp_crypto_asset_hired_description_text" />
                </div>
            </div>
            <div className='crypto-assets__amount'>
                {
                    isFetchError
                        ? <FormattedText value="gp_crypto_asset-gp_crypto_asset_offer_error_text" />
                        : (
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        )
                }
            </div>
        </div>
    );
}
